import React, { useEffect, useState, useRef } from 'react';
interface CounterProps {
  end: number;
  start?: number;
  duration?: number;
  prefix?: string;
  suffix?: string;
  className?: string;
}
export function Counter({
  end,
  start = 0,
  duration = 2000,
  prefix = '',
  suffix = '',
  className = ''
}: CounterProps) {
  const [count, setCount] = useState(start);
  const countRef = useRef(start);
  const rafRef = useRef<number | null>(null);
  const startTimeRef = useRef<number | null>(null);
  useEffect(() => {
    // Reset when end changes
    countRef.current = start;
    startTimeRef.current = null;
    const animate = (timestamp: number) => {
      if (startTimeRef.current === null) {
        startTimeRef.current = timestamp;
      }
      const progress = Math.min((timestamp - startTimeRef.current) / duration, 1);
      const currentCount = Math.floor(progress * (end - start) + start);
      if (countRef.current !== currentCount) {
        countRef.current = currentCount;
        setCount(currentCount);
      }
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };
    rafRef.current = requestAnimationFrame(animate);
    return () => {
      if (rafRef.current !== null) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, [end, start, duration]);
  return <span className={className} data-id="element-943">
      {prefix}
      {count.toLocaleString()}
      {suffix}
    </span>;
}